import axiosInstance from './axios';

export interface LoginResponse {
  status: number;
  message: string;
  data: {
    id: string;
    fullName: string;
    profileImage?: string;
  };
  accessToken: string;
  refreshToken: string;
  isExists: boolean;
}

export interface RegisterResponse {
  status: number;
  message: string;
  data: {
    id: string;
    fullName: string;
  };
  accessToken: string;
  refreshToken: string;
}

export interface RefreshTokenResponse {
  status: number;
  message: string;
  data: {
    accessToken: string;
    refreshToken: string;
  };
}

export interface ConfigResponse {
  status: number;
  message: string;
  data: {
    googleLocationConfig: {
      apiKey: string;
    };
  };
}

export const authApi = {
  sendOtp: async (phone: string, countryCode: string) => {
    const response = await axiosInstance.post('/users/send-otp', {
      phone,
      countryCode,
    });
    return response.data;
  },

  verifyOtp: async (phone: string, otp: string, countryCode: string) => {
    const response = await axiosInstance.post('/users/verify-otp', {
      phone,
      otp,
      countryCode,
    });
    return response.data as LoginResponse;
  },

  register: async (fullName: string, mobileNumber: string, countryId: string) => {
    const response = await axiosInstance.post('/users/register', {
      fullName,
      mobileNumber,
      countryId,
    });
    return response.data as RegisterResponse;
  },

  refreshToken: async (refreshToken: string) => {
    const response = await axiosInstance.post('/users/refresh-token', {
      refreshToken,
    });
    return response.data as RefreshTokenResponse;
  },

  logout: async (refreshToken?: string) => {
    const response = await axiosInstance.post('/users/logout', {
      refreshToken,
    });
    return response.data;
  },

  getConfig: async () => {
    const response = await axiosInstance.get('/config');
    return response.data as ConfigResponse;
  },
}; 